import './tools.css';
import { useState, useEffect } from 'react';

export function Tools({ style }) {
  const [layersCount, setLayersCount] = useState(2); // default for laptop/desktop

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 1024) setLayersCount(3); // tablet & mobile
      else setLayersCount(2); // laptop/desktop
    };

    handleResize(); // set initial layers
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const mostUsedTools = [
    { name: "VSCODE", img: "vccode.png" },
    { name: "STS", img: "spring.png" },
    { name: "ECLIPSE", img: "Eclipse.png" },
    { name: "GIT", img: "git.png" },
    { name: "GITHUB", img: "github2.png" },
    { name: "JUNIT", img: "junit.png" },
    { name: "ELK", img: "elk.png" },
    { name: "GRADLE", img: "Gradle.png" },
    { name: "POSTMAN", img: "Postman.png" },
    { name: "K8S", img: "kubernetes.png" },
    { name: "INTELLIJ", img: "intellij_idea.png" },
    { name: "MOCKITO", img: "Mockito.png" },
    { name: "FIGMA", img: "FIGMA.png" },
    { name: "CANVA", img: "CANVA.png" },
  ];

  const experiencedTools = [
    { name: "SWAGGER", img: "Swagger.png" },
    { name: "SPRING", img: "spring.png" },
    { name: "Maven", img: "Maven.png" },
    { name: "ECLIPSE", img: "Eclipse.png" },
    { name: "GIT", img: "git.png" },
    { name: "GITHUB", img: "github2.png" },
    { name: "JUNIT", img: "junit.png" },
    { name: "REST-API", img: "rest-api.png" },
    { name: "REDIS", img: "redis.png" },
    { name: "ELK", img: "elk.png" },
    { name: "SPLINE", img: "spiline.png" },
  ];

  const renderTechCards = (techArray) => {
    const layerSize = Math.ceil(techArray.length / layersCount);
    const layers = [];
    for (let i = 0; i < layersCount; i++) {
      const start = i * layerSize;
      const end = start + layerSize;
      const layerItems = techArray.slice(start, end);
      if (layerItems.length > 0) {
        layers.push(
          <div className="exp-box1" key={i}>
            {layerItems.map((tech, index) => (
              <div className="ImgOfBoxTech" key={index}>
                <img src={tech.img} alt={tech.name} />
                <h5>{tech.name}</h5>
              </div>
            ))}
          </div>
        );
      }
    }
    return layers;
  };

  return (
    <div className={`container-fluid all-tech-page ${style}`}>
      <div className="box1">
        <div className="mb-3"><span>Most Used</span></div>
        <div className="all-exp-card">
          {renderTechCards(mostUsedTools)}
        </div>
      </div>
      <div className="box2">
        <div><span>Experienced</span></div>
        <div className="all-exp-card">
          {renderTechCards(experiencedTools)}
        </div>
      </div>
    </div>
  );
}
